/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Author/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Author({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Note/Content/Display/Author"
  
}) {
let noteDateValueData = fromData.useDataFormat({ viewPath,
context: 'note',
path: 'date',
format: fromHelpers.formatDateTime,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let noteCreatorPersonValueData = fromData.useDataFormat({ viewPath,
context: 'note',
path: 'creator.person',
format: fromFormat.personName,
})
  return (<React.Fragment
>
<div
  data-testid="Author.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="note.date"
 format="helpers.js formatDateTime"
 text={noteDateValueData}
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="by"
 marginLeft={dtSpaceXxs}
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="note.creator.person"
 format="/Data/format.js personName"
 text={noteCreatorPersonValueData}
 color={dtColorsNeutral600}
 marginLeft={dtSpaceXxs}
 weight="bold"
/>
</div>
{children}
</React.Fragment>)
}